import { Theme } from "@material-ui/core/styles";

export function SetMuiToggleButtonGroupBorders(theme: Theme, spaceBetweenButtons?: number) {
  return {
    borderRadius: theme.shape.borderRadius,
    "&:not(:last-child)": {
      borderTopRightRadius: theme.shape.borderRadius,
      borderBottomRightRadius: theme.shape.borderRadius,
    },
    "&:not(:first-child)": {
      borderLeft: "",
      marginLeft: spaceBetweenButtons ?? theme.spacing(2),
      borderTopLeftRadius: theme.shape.borderRadius,
      borderBottomLeftRadius: theme.shape.borderRadius,
    },
  };
}

export const CommonBase = {
  MuiToggleButtonGroup: {
    root: {
      backgroundColor: "inherit",
      justifyContent: "space-between",
    },
    groupedHorizontal: {
      flex: 1,
    },
  },
  MuiToggleButton: {
    root: {
      textTransform: "inherit",
    },
  },
};
